<script lang="ts">
    const component = {
        name: 'FloatingContainer',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = defineProps<{
        direction?: string;
    }>();
</script>

<template>
    <div class="container-floating" :class="direction">
        <slot />
    </div>
</template>

<style lang="less">
    .container-floating {
        --border-size: 0.24rem;
        // --border-radius: var(--border-radius);

        display: flex;
        position: absolute;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: calc(0.55rem + var(--border-size) * 2);
        /* overflow: hidden; */
        z-index: 10;

        background-color: #fff; /* fallback */
        /* background-image: linear-gradient(160deg, #ffffff, 42%, hsl(176deg 75% 95%)); */
        border-radius: var(--border-radius);
        box-shadow:
            0.1rem 0.5rem 0.7rem -0.2rem #00000015,
            -0.4rem -0.3rem 1rem -0.6rem #00000040;

        outline: var(--border-size) solid hsl(353deg 100% 98%);
    }
    .container-floating.horizontal {
        flex-direction: row;

        width: auto;
        height: calc(2rem + var(--border-size) * 2);
        min-height: calc(2rem + var(--border-size) * 2);
        height: 2rem;
        min-height: 2rem;
    }
    .container-floating.vertical {
        flex-direction: column;

        width: calc(2rem + var(--border-size) * 2);
        min-height: calc(2rem + var(--border-size) * 2);
        width: 2rem;
        min-height: 2rem;
    }
    /* button radius of child elements*/
    .container-floating.horizontal > :first-child {
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
    }
    .container-floating.horizontal > :last-child {
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
    }
    .container-floating.vertical > :first-child {
        border-top-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);
    }
    .container-floating.vertical > :last-child {
        border-bottom-left-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
    }

    .container-floating .fluid-button,
    .container-floating .option-group,
    .container-floating .input-wrapper {
        height: 2rem;
        width: 2rem;
    }

    .fluid-toggle.small .input-wrapper {
        align-items: center;
        justify-content: center;
    }
    .fluid-toggle.small .styled-button {
        height: 16px;
        width: 16px;
        border-radius: 4px;
    }
    .fluid-toggle.small .styled-button:after {
        height: 0.775rem;
        width: 0.775rem;
        border-radius: 3px;
    }

    .container-floating svg {
        height: 0.9rem;
        width: 0.9rem;
    }

    .separator {
        display: block;
        background-color: var(--clr-silver);
        opacity: 0.6;
    }

    .separator.horizontal {
        height: 1px;
        width: 1.4rem;
        margin: 0.4rem auto;
    }
    .separator.vertical {
        height: 1.4rem;
        width: 0.1rem;
        margin: auto 0.4rem;
    }

    .option-group {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        flex-direction: row;
    }
</style>
